<div class="history">
  <header>

    <!-- <a class="btn btn-default btn-sm form-control" (click)="open(info)">
      Profile Information
    </a> -->
    <div class="modal-body" style="color:white; width: 400px;">

      <label>Name: &nbsp;</label>{{userInfo.FULL_NAME}}
      <br>
      <label>Email: &nbsp;</label>{{userInfo.USER_EMAIL}}
      <br>
      <label>Phone: &nbsp;</label>{{userInfo.PHONE_NUMBER}}
      <br>
      <label>Company: &nbsp;</label> {{userInfo.COMPANY_NAME}}
      <br>
      <label>Signature: &nbsp;</label><a *ngIf="userInfo.SIGNATURE_URL && userInfo.SIGNATURE_URL!=''" (mouseenter) ="op1.toggle($event)"  (mouseleave) ="op1.toggle($event)" target="_blank" [href]="userInfo.SIGNATURE_URL" style="color:rgb(195,212,47);cursor:pointer">Signature Link</a>
      <a style="cursor:pointer;" class="ml-1"
        (click)="op2.toggle($event); ">
        <i class="fas fa-edit erisGreen1 m-1"></i>
      </a>
                    <p-overlayPanel #op1 [appendTo]="'body'">
                      <img style="max-width:200px; max-height:200px; height: auto; 
                      width: auto; "[src]="userInfo.SIGNATURE_URL">
                    </p-overlayPanel>

                  <p-overlayPanel #op2 [appendTo]="'body'">
                    <input #signature type="file" style="display:none" (change)="getName2();" accept=".jpg,.png,.jpeg"/>
                    <a class="form-control"
                      style="margin-left:0;border-color:#999; display:inline-block; width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-decoration: none;"
                      (click)='selectFile2()' aria-label="Recipient's username"
                      aria-describedby="basic-addon2">{{curRptPara2.name}}</a>
                    <button type="button" class="btn btn-sm uploadBtn"
                      (click)="changeSignature(curRptPara2, userInfo); op2.hide();"
                      style="margin-left: 5px;transform: translateY(-16px)">Upload</button>
                    <div style="font-size:11px">
                      Signature image should be at least (but not exceed) 300 x 100 pixels (width x height).
                      </div>
                    <div style="font-size:11px">
                      We accept jpeg, png, and jpg formats.
                    </div>
                  </p-overlayPanel>
      <br>
      
      <label>Resume: &nbsp; </label> <a style="font-weight:400;  cursor:pointer" (click)="op3.toggle($event);">
        <i class="fas fa-file-upload erisGreen1"></i>
      </a>

      <div *ngFor="let resume of userInfo.RESUMES; let j=index" style="font-weight:400">
        <a style="cursor:pointer; white-space: wrap; overflow: hidden; text-overflow: ellipsis;" class="erisGreen1" (click)="showDeleteResumeConfirm(userInfo, resume, j)"><i
          class="fas fa-times"></i></a> &nbsp; <a style="color:rgb(195,212,47)" target="_blank"
          [href]="resume.RESUME_URL">{{resume.RESUME_TITLE}}</a>
      </div>
      <!-- <a style="font-weight:400; float:right; cursor:pointer" (click)="op1.toggle($event)"><i
            class="fas fa-file-upload erisGreen m-1"></i></a> -->
                  <p-overlayPanel #op3 [appendTo]="'body'">
                    <input id="resume" type="file" class="testtofind" style="display:none" (change)="getName();" accept=".txt,.docx,.doc,.pdf,.PDF"/>
                    <a class="form-control"
                      style="margin-left:0; border-color:#999; display:inline-block; width: 200px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-decoration: none;"
                      (click)='selectFile()' aria-label="Recipient's username"
                      aria-describedby="basic-addon2">{{curRptPara.name}}</a>
                    <button type="button" class="btn btn-sm uploadBtn"
                      (click)="addResume(curRptPara, userInfo); op3.hide();"
                      style="margin-left: 5px; transform: translateY(-16px)">Upload</button>
                  </p-overlayPanel>

      <br>
      <span *ngIf="userInfo.ERIS_CUSTOMER_ID"> <label>ERIS Account:&nbsp;</label> {{userInfo.ERIS_USERNAME}} </span>
      <span *ngIf="!userInfo.ERIS_CUSTOMER_ID">
        <a data-toggle="modal" data-target="#ERIS" style="cursor:pointer; text-decoration :underline;">Have ERIS Account?</a>

      </span>
      <br>
      <a href="javascript:void(0)" *ngIf='userInfo.USER_SSO_IND=="N"' style="color:rgb(195,212,47)" data-target="#resetModal" data-toggle="modal" (click)="startReset();">Reset Password</a><br>
      <a href="javascript:void(0)" *ngIf='userInfo.MOBILE_PASSWORD_SSO=="Y"' style="color:rgb(195,212,47)" data-target="#mobileModal" data-toggle="modal" (click)="startMobilePsw();">Setup Mobile Password</a>
    <a href="javascript:void(0);" class="btn btn-default btn-m form-control" title="Log Out" (click)="logout()">
      Log Out
    </a></div>
  </header>
  <div id="resetModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">

    <div class="modal-dialog modal-dialog-centered" style="max-width:30%">
      <div class="modal-content" style="background-color:#cDcDcD">

        <div class="modal-header">
          <h6 class="modal-title">Reset Password</h6>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>


        <div class="modal-body">
          <div class="container">
            <div *ngIf="toReset">
              <form [formGroup]="resetForm">
                <label style="font-weight:normal" class=col-md-6>
                  Existing Password:<span style="color:red" *ngIf="!resetForm.controls.oldpassword.pristine && !resetForm.controls.oldpassword.valid || !resetForm.value.oldpassword"> *</span>
                </label>
                <input class="form-control mb-2" type="password" style="padding:0px" #oldpassword id="oldpassword" [class.invalid]="!resetForm.controls.oldpassword.pristine && !resetForm.controls.oldpassword.valid"  formControlName="oldpassword">
                
              
              
              <label style="font-weight:normal" class=col-md-6>
                New Password:<span style="color:red" *ngIf="!resetForm.controls.password.pristine && !resetForm.controls.password.valid || !resetForm.value.password"> *</span>
              </label>
              <input class="form-control mb-2" type="password" style="padding:0px; color:black" #password id="password" [class.invalid]="!resetForm.controls.password.pristine && !resetForm.controls.password.valid"  formControlName="password">
              
            
            
            <label style="font-weight:normal" class=col-md-6>
              Retype Password:<span style="color:red" *ngIf="!resetForm.controls.confirmpassword.pristine && !resetForm.controls.confirmpassword.valid || !resetForm.value.confirmpassword"> *</span>
            </label>
            <input class="form-control mb-2" type="password" style="padding:0px" [class.newmargin]= "resetForm.value.password!= resetForm.value.confirmpassword" #confirmpassword id="confirmpassword" [class.invalid]="!resetForm.controls.confirmpassword.pristine && (!resetForm.controls.confirmpassword.valid || (resetForm.value.password!= resetForm.value.confirmpassword))"  formControlName="confirmpassword">
            <span *ngIf = "passwordCheck">
              <ul>
                <li style='margin-bottom:5px' *ngIf="resetForm.value.password!= resetForm.value.confirmpassword" style="color:red">
                  New Passwords are not the same
                </li>
                <li style='margin-bottom:5px' *ngIf="resetForm.controls.password.errors!==null && resetForm.controls.password.errors.pattern!==undefined" style="color:red">
                  Password must be at least 8 characters in length, and contain at least 1 uppercase character, 1 lowercase character, 1 symbol, and 1 number.
                </li>
              </ul>
            </span>
            
            <div *ngIf = "resetWarn">
              <span style='margin-bottom:5px'  style="color:red">
              {{reseWarnMessage}}
              </span>
            </div>
            <button class="btn btn-outline-dark m-1 float-right" (click)="resetPsw();passwordCheck=true">Reset Password</button>
          </form>
          
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="mobileModal" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">

    <div class="modal-dialog modal-dialog-centered" style="max-width:30%">
      <div class="modal-content" style="background-color:#cDcDcD">

        <div class="modal-header">
          <h6 class="modal-title">Setup Mobile Password</h6>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>


        <div class="modal-body">
          <div class="container">
            <div *ngIf="toMbileSet">
              <form [formGroup]="resetForm1">
               <label style="font-weight:normal" class=col-md-6>
                Mobile Password:<span style="color:red" *ngIf="!resetForm1.controls.password.pristine && !resetForm1.controls.password.valid || !resetForm1.value.password"> *</span>
              </label>
              <input class="form-control mb-2" type="password" style="padding:0px; color:black" #password id="password" [class.invalid]="!resetForm1.controls.password.pristine && !resetForm1.controls.password.valid"  formControlName="password">
              
            
            
            <label style="font-weight:normal" class=col-md-6>
              Retype Password:<span style="color:red" *ngIf="!resetForm1.controls.confirmpassword.pristine && !resetForm1.controls.confirmpassword.valid || !resetForm1.value.confirmpassword"> *</span>
            </label>
            <input class="form-control mb-2" type="password" style="padding:0px" [class.newmargin]= "resetForm1.value.password!= resetForm1.value.confirmpassword" #confirmpassword id="confirmpassword" [class.invalid]="!resetForm1.controls.confirmpassword.pristine && (!resetForm1.controls.confirmpassword.valid || (resetForm1.value.password!= resetForm1.value.confirmpassword))"  formControlName="confirmpassword">
            <span *ngIf = "passwordCheck">
              <ul>
                <li style='margin-bottom:5px' *ngIf="resetForm1.value.password!= resetForm1.value.confirmpassword" style="color:red">
                  New Passwords are not the same
                </li>
                <li style='margin-bottom:5px' *ngIf="resetForm1.controls.password.errors!==null && resetForm1.controls.password.errors.pattern!==undefined" style="color:red">
                  Password must be at least 8 characters in length, and contain at least 1 uppercase character, 1 lowercase character, 1 symbol, and 1 number.
                </li>
              </ul>
            </span>
            
            <div *ngIf = "resetWarn">
              <span style='margin-bottom:5px'  style="color:red">
              {{reseWarnMessage}}
              </span>
            </div>
            <button class="btn btn-outline-dark m-1 float-right" (click)="setMobilePsw();passwordCheck=true">Set Mobile Password</button>
          </form>
          
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="ERIS" class="modal fade" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="false">

    <div class="modal-dialog modal-dialog-centered" style="max-width:30%">
      <div class="modal-content" style="background-color:#cDcDcD">

        <div class="modal-header">
          <h6 class="modal-title">Login To ERIS</h6>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>


        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <label class=col-md-4 style="font-weight:normal">
                  Username:
                </label><input class="col-md-5" style="padding:0px" type="text" [(ngModel)]="ERIS_USERNAME">
              </div>
              <div class="col-md-12">

                <label style="font-weight:normal" class=col-md-4>
                  Password:
                </label>
                <input class="col-md-5" type="password" style="padding:0px" [(ngModel)]="ERIS_PASSWORD">
                <button class="btn btn-gray1 float-right mt-2" (click)="verifyEris();">Verify ERIS Account</button>
              </div>
              <div class="col-md-12" *ngIf="incorrect" style="color:red">
                Incorrect ERIS Login Information
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #info let-modal>
    <!-- <div class="modal-dialog"> -->
    <!-- <div class="modal-header">
					<h4>Sign In</h4>
				</div> -->
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Profile Information</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      Name: {{userInfo.FULL_NAME}}
      <br>
      Email: {{userInfo.USER_EMAIL}}
      <br>
      Phone: {{userInfo.PHONE_NUMBER}}
      <br>
      Company: {{userInfo.COMPANY_NAME}}
      <br>
      Signature:                     <a  (mouseenter) ="op1.toggle($event)"  (mouseleave) ="op1.toggle($event)" target="_blank" [href]="userInfo.SIGNATURE_URL" style="color:rgb(195,212,47);cursor:pointer">Signature Link</a>
      <a style="cursor:pointer;"
      (click)="op2.toggle($event); "><i class="fas fa-edit erisGreen1 m-1"></i></a>
                    <p-overlayPanel #op1 [appendTo]="'body'">
                      <img style="max-width:200px; max-height:200px; height: auto; 
                      width: auto; "[src]="userInfo.SIGNATURE_URL">
                    </p-overlayPanel>

                  <p-overlayPanel #op2 [appendTo]="'body'">
                    <input #signature type="file" style="display:none" (change)="getName2();" accept=".jpg,.png,.jpeg"/>
                    <label class="form-control"
                      style="margin-left:0; height:24px; padding:4px; font-size:.9em; color:#000;border-color:#999; line-height:0.8; display:inline-block; width: 200px"
                      (click)='selectFile2()' aria-label="Recipient's username"
                      aria-describedby="basic-addon2">{{curRptPara2.name}}</label>
                    <button type="button" class="btn uploadBtn"
                      (click)="changeSignature(curRptPara2, userInfo); op2.hide();"
                      style="margin-left: 5px; padding: 3px; font-size: 12px;">Upload</button>
                  </p-overlayPanel>
      <br>
      Resume:
      <div *ngFor="let resume of userInfo.RESUMES; let j=index" style="font-weight:400">
        <a style="cursor:pointer " class="erisGreen1" (click)="showDeleteResumeConfirm(userInfo, resume, j)"><i
            class="fas fa-times"></i></a> &nbsp; <a style="color:rgb(195,212,47)" target="_blank"
          [href]="resume.RESUME_URL">{{resume.RESUME_TITLE}}</a>
      </div>
      <!-- <a style="font-weight:400; float:right; cursor:pointer" (click)="op1.toggle($event)"><i
                class="fas fa-file-upload erisGreen m-1"></i></a> -->

      <a style="font-weight:400; float:right; cursor:pointer" (click)="op1.toggle($event)"><i
          class="fas fa-file-upload erisGreen1"></i></a>

      <p-overlayPanel #op1 [appendTo]="'body'" [style]="{'width':'300px'}">
        <input id="resume" type="file" class="testtofind" style="display:none" (change)="getName();" accept=".txt,.docx,.doc,.pdf,.PDF"/>
        <label class="form-control"
          style="margin-left:0; height:24px; padding:4px; font-size:.9em; color:#000;border-color:#999; line-height:0.8; display:inline-block; width: 200px"
          (click)='selectFile()' aria-label="Recipient's username"
          aria-describedby="basic-addon2">{{curRptPara.name}}</label>
        <button type="button" class="btn btn-primary" (click)="addResume(curRptPara, userInfo);"
          style="margin-left: 5px; padding: 3px; font-size: 12px;">Upload</button>
      </p-overlayPanel>
      <br>
      <span *ngIf="userInfo.ERIS_CUSTOMER_ID"> ERIS Account: {{userInfo.ERIS_CUSTOMER_ID}} </span>
      <span *ngIf="!userInfo.ERIS_CUSTOMER_ID"> ERIS Account Login:
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <label class=col-md-4>
                Username:
              </label><input class="col-md-5" style="padding:0px" type="text" [(ngModel)]="ERIS_USERNAME">
            </div>
            <div class="col-md-12">

              <label class=col-md-4>
                Password:
              </label>
              <input class="col-md-5" type="text" style="padding:0px" [(ngModel)]="ERIS_PASSWORD">
            </div>
            <div class="col-md-12" *ngIf="incorrect" style="color:red">
              Incorrect Eris Login Information
            </div>
            <button class="btn btn-gray1 float-right mt-2" (click)="verifyEris();">Verify ERIS Account</button>
          </div>

        </div>
      </span>
    </div>
    <!-- </div> -->
  </ng-template>
  <!-- <div style="margin-top:10px; border: solid 1px #c3d42f; ">
    <p class="ptitle">Company Logo(s)</p>
    <div class="input-group " style="margin: 10px;">
      <div class='form-group col-md-9'>
        <input #file type="file" class='form-control-file' />
      </div>
      <div class="col-md-3">
       
        <a id="uploadBtn" href="javascript:void(0)" (click)="addLogo()">
          <i class="fas fa-cloud-upload-alt fa-2x" style="color:rgb(195,212,47); "></i>
        </a>
      </div>

    </div>
    <main *ngIf="logos" style="overflow-x: hidden !important;">
      <div class="norecords" *ngIf="logos.length === 0">
        <p>No saved logo found</p>
      </div>
      <ul *ngIf="logos.length > 0" class="reports">
        <li *ngFor="let logo of logos">
          <div class="article" [class.selected]="logo.LOGO_ID === reportService.defaultLogo?.LOGO_ID">
            <img *ngIf="logo.LOGO_THUMBNAIL" [src]="logo.LOGO_THUMBNAIL" />
            <span class="title" [title]="logo.LOGO_TITLE || logo.LOGO_ID">{{logo.LOGO_TITLE}}</span>

            <div class="actions">
              <a href="javascript:void(0);" title="select" (click)="chooseLogo(logo.LOGO_ID)">
                <i class="fa fa-check"></i>
              </a>
              <a *ngIf="logo.LOGO_URL" [href]="logo.LOGO_URL" title="Logo" target="_blank">
                <i class="fa fa-file-image-o"></i>
              </a>
              <a href="javascript:void(0);" title="delete" (click)="onDeleteLogo(logo)">
                <i class="fa fa-trash"></i>
              </a>
            </div>
          </div>

        </li>
      </ul>
    </main>
  </div> -->
</div>